:host {
  display: block;
}

a {
  position: relative;
  height: 100%;
  font-family: $font-family-base;
  font-size: 14px;
  line-height: 18px;
  text-align: center;
  padding: 14px 8px 14px 8px;
  color: $navigation-meta-link-font-color;
  background-color: $navigation-meta-link-bg-color;
  text-decoration: none;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  cursor: pointer;

  &::after {
    content: "";
    position: absolute;
    left: 0;
    bottom: -2px;
    width: 100%;
    height: 2px;
    background-color: $navigation-meta-link-border-color;
  }

  &:hover {
    color: $navigation-meta-link-font-color-hover;
    background-color: $navigation-meta-link-bg-color-hover;

    &::after {
      background-color: $navigation-meta-link-border-color-hover;
    }
  }

  &:focus {
    color: $navigation-meta-link-font-color-focus;
    background-color: $navigation-meta-link-bg-color-focus;
    outline: none;

    &::after {
      background-color: $navigation-meta-link-border-color-focus;
    }
  }

  &.#{$prefix}current {
    color: $navigation-meta-link-font-color-current;
    background-color: $navigation-meta-link-bg-color-current;

    &::after {
      background-color: $navigation-meta-link-border-color-current;
    }

    &:hover {
      color: $navigation-meta-link-font-color-current-hover;
      background-color: $navigation-meta-link-bg-color-current-hover;

      &::after {
        background-color: $navigation-meta-link-border-color-current-hover;
      }
    }

    &:focus {
      color: $navigation-meta-link-font-color-current-focus;
      background-color: $navigation-meta-link-bg-color-current-focus;
      outline: none;

      &::after {
        background-color: $navigation-meta-link-border-color-current-focus;
      }
    }
  }
}
